import axios from "axios";
import {getOptions} from "../../helpers/api";

export const boards = {

  getBoardsFilterLookups: (data) => {
    const { headers } = getOptions(data);
    return axios.get('/mashhad.api/Ticket/GetFilterLookups', headers);
  },

  getBoardTickets: (data) => {
    const { headers } = getOptions(data);
    return axios.post('/mashhad.api/Ticket/GetTickets', data.body, headers);
  },

  createTicket: (data) => {
    const { headers } = getOptions(data);
    return axios.post('/mashhad.api/Ticket/SaveTicket', data.body, headers);
  },

  removeTicket: (data) => {
    const { params, headers } = getOptions(data);
    return axios.post('helpdeskdashboard/remove/ticket', params, headers);
  },

  addTicketRemarks: (data) => {
    const { headers } = getOptions(data);
    return axios.post('/mashhad.api/Ticket/SaveTicketRemarks', data.body, headers);
  },

  getTicketDetails: (data) => {
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/Ticket/GetTicketDetails/${data.id}`, headers);
  },

  getUserManagement: (data) => {
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/UserManagement/users?roles=${data.roles}&q=${data.user}`, headers);
  },

  getTicketAging: (data) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/Ticket/GetTicketAging`, data.body, headers);
  },

  getTicketSummaryStages: (data) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/Ticket/GetStatusChartSummary`, data.body, headers);
  },
  getTicketSummaryAging: (data) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/Ticket/GetAgingChartSummary`, data.body, headers);
  },
  exportTicketList: (data) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/Ticket/ExportTicketList`, data.body, { responseType: "blob", ...headers });
  },
  exportTicketLog: (data) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/Ticket/ExportTicketLog`, data.body, { responseType: "blob", ...headers });
  },

};